import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Switching to feed readers",
  "description": "",
  "published": "2008-10-08T00:00:00.000Z",
  "redirect_from": ["/blog/switching-to-feed-readers/swizec/60"],
  "categories": "blog, feeds, improvement, life, time",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When I was redesigning my blog I had the marvelous idea of adding a reBlog widget to the sidebar on the left. The main reason behind this idea was that since my readers hopefully enjoy what i have to say they might also enjoy giving a glance or two to the things I read myself, seeming as how when it comes to authors of published works people are always interested in seeing where the influence and ideas come from. Therefore I decided to simplify this process for people and a conventional blogroll simply wasn't enough.`}</p>
    <p>{`Why it wasn't enough, though, is a complex reason. Mainly I find them to be overly static, quite boring and rarely attracting any sort of attention. My reBlog feature on the other hand is useful to make my website a tad more dynamic, which is something google and other search engines love very much. it also serves as a simple way to be quickly involved in any buzz going through the blogosphere ... also raising hits.`}</p>
    <p>{`The most profound change in my life coming from adding reblog was that it suddenly made me realise how awesome feed readers are. I was probably wasting several hours daily on making sure I kept up to date on everything from slashdot to different blogs and more often than not I'd simply forget about a blog or two and then be happily surprised when I found them again later. This is why I promptly installed `}<a parentName="p" {...{
        "href": "http://akregator.kde.org/"
      }}>{`Akregator`}</a>{` on my home computer and `}<a parentName="p" {...{
        "href": "http://www.vienna-rss.org/"
      }}>{`Vienna`}</a>{` on my mac.`}</p>
    <p>{`Vienna I don't like so much, it's better than others but I do have my qualms. Akregator is rather awesome though and now my life is simpler. So here's to a simpler life via RSS feeds!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      